import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../css/preload.min.css";
import "../css/icomoon.css";
import "../css/about.min.css";
import "../css/index.min.css";
import default_banner from "../img/golf-image.jpg";

import "../scss/custom.scss";
import logo from "../img/loho.png";
import axios from "axios";
import CountdownTimer from "../components/CountdownBanner";
import { getPricingInfo } from "../utils/pricingUtils";

const Home = () => {
  const [data, setData] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [showError, setShowError] = useState(false);
  const [disabled, setDisabled] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [teams, setTeams] = useState([]);
  const pricing = getPricingInfo();

  const handleChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  useEffect(() => {
    if (
      data.team_name &&
      data.email &&
      data.player_1 &&
      data.player_2 &&
      data.player_3 &&
      data.player_4 &&
      data.asq
    ) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  }, [data]);

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    try {
      const response = await axios.get(
        "https://ihm-golf-tournament-spreadsheet.vercel.app/teams",
      );
      if (response.data) {
        setTeams(response.data);
        console.log(response.data);
      } else {
        console.log("No data found.");
      }
    } catch (error) {
      console.error(error);
    }
  };

  const submitForm = async () => {
    setSubmitting(true);
    try {
      if (data.asq === "4") {
        let result = await axios.post(
          `https://ihm-golf-tournament-spreadsheet.vercel.app/teams`,
          data,
        );
        if (result.status === 200) {
          setShowSuccess(true);
        } else {
          setShowError(
            "There was an error submitting your registration.  Please try again later.",
          );
        }
      } else {
        setShowError(
          "You've incorrectly answered the anti-bot question.  Please refresh and try again.",
        );
      }
    } catch (error) {
      setShowError(
        "There was an error submitting your registration. Please try again later.",
      );
      console.error(error);
    } finally {
      setSubmitting(false);
    }
  };

  // Sticky Menu Area
  useEffect(() => {
    window.addEventListener("scroll", isSticky);
    return () => {
      window.removeEventListener("scroll", isSticky);
    };
  });

  const mappedArray = teams.map((innerArray) => {
    return (
      <tr>
        {innerArray.map((value, index) => {
          if (index !== 1 && index !== 6) {
            return <td key={index}>{value}</td>;
          }
          return null;
        })}
      </tr>
    );
  });

  /* Method that will fix header after a specific scrollable */
  const isSticky = (e) => {
    const header = document.querySelector(".headroom");
    const scrollTop = window.scrollY;
    if (header) {
      scrollTop >= 250
        ? header.classList.add("is-sticky")
        : header.classList.remove("is-sticky");
    }
  };
  return (
    <>
      {/*<Header nav="false" />*/}
      {/* homepage content start */}
      <main>
        <div className="">
          <CountdownTimer />
        </div>
        {/* hero section start */}
        <div className="hero-container">
          <div className="overlay">
            <picture>
              <source data-srcset={default_banner} srcSet={default_banner} />
              <img
                className="lazy"
                data-src={default_banner}
                src={default_banner}
                alt="media"
              />
              <div className="overlay"></div>
            </picture>
          </div>
          <section className="hero section">
            <div
              data-aos="zoom-in"
              className="container container--hero d-lg-flex align-items-center justify-content-center"
            >
              <div className="">
                <img
                  className="banner-logo"
                  src={logo}
                  alt="IHM GOLF TOURNAMENT"
                ></img>
                <h1>
                  <span className="subtitle">Immaculate Heart of Mary</span>
                  <br /> Golf Tournament
                </h1>
                <p>
                  <i className="icon-location"></i> THE PONDS GOLF COURSE
                </p>
                <div className="hero_main-content center">
                  {/*<span className="line"></span> 
                <p className="text">
                  Sign up and pay below
                </p>
                */}
                </div>
                {/*<div className="item-wrapper d-sm-flex flex-wrap flex-lg-nowrap justify-content-center align-items-lg-center">
                <a className="btn theme-element theme-element--accent m-1" type="submit" href="tel:763-434-3686">
                  SIGN UP AND PAY
                </a>
              </div>*/}
              </div>
            </div>
          </section>
        </div>

        {/* hero section end */}
        {/* rooms section start */}
        <div class="main-content">
          <nav className="breadcrumbs">
            <div className="container">
              <a href="/">Home</a>
              <span className="separator">/</span>
              <span className="current">Team Registration</span>
            </div>
          </nav>
          <section className="section dark primary-bg main">
            <div className="block" />
            <div className="container">
              <div className=" align-items-center mb-1">
                <h3 className="max-width" data-aos="fade-right">
                  Registration and Payment
                </h3>
                <p>
                  Register your team here.
                  <br />
                  <strong>All fields required.</strong>
                </p>
                <div className="contacts_secondary-form" data-aos="fade-left">
                  <div className="contacts" data-aos="fade-left">
                    <div className="contacts_header">
                      <p className="input-grouping">
                        <span>Team Name</span>
                        <div className="field-wrapper mt-2">
                          <input
                            onChange={handleChange}
                            value={data.team_name}
                            className="field required"
                            id="feedbackName"
                            type="text"
                            placeholder="Enter Team Name"
                            name="team_name"
                          />
                        </div>
                      </p>
                      <p className="input-grouping">
                        <span>Email</span>
                        <div className="field-wrapper mt-2">
                          <input
                            className="field required"
                            id="feedbackName"
                            type="text"
                            placeholder="Enter Email Address"
                            onChange={handleChange}
                            name="email"
                            value={data.email}
                          />
                        </div>
                      </p>
                      <div className="row">
                        <div className="col-lg-3">
                          <p className="input-grouping">
                            <span>Player 1</span>
                            <div className="field-wrapper mt-2">
                              <input
                                className="field required"
                                id="feedbackName"
                                type="text"
                                placeholder="Enter Player 1"
                                onChange={handleChange}
                                name="player_1"
                                value={data.player_1}
                              />
                            </div>
                          </p>
                        </div>
                        <div className="col-lg-3">
                          <p className="input-grouping">
                            <span>Player 2</span>
                            <div className="field-wrapper mt-2">
                              <input
                                className="field required"
                                id="feedbackName"
                                type="text"
                                placeholder="Enter Player 2"
                                onChange={handleChange}
                                name="player_2"
                                value={data.player_2}
                              />
                            </div>
                          </p>
                        </div>
                        <div className="col-lg-3">
                          <p className="input-grouping">
                            <span>Player 3</span>
                            <div className="field-wrapper mt-2">
                              <input
                                className="field required"
                                id="feedbackName"
                                type="text"
                                placeholder="Enter Player 3"
                                onChange={handleChange}
                                name="player_3"
                                value={data.player_3}
                              />
                            </div>
                          </p>
                        </div>
                        <div className="col-lg-3">
                          <p className="input-grouping">
                            <span>Player 4</span>
                            <div className="field-wrapper mt-2">
                              <input
                                className="field required"
                                id="feedbackName"
                                type="text"
                                placeholder="Enter Player 4"
                                onChange={handleChange}
                                name="player_4"
                                value={data.player_4}
                              />
                            </div>
                          </p>
                        </div>
                      </div>
                      <p className="input-grouping">
                        <p className="mt-5">
                          <strong>Anti-Bot Question</strong>
                        </p>
                        <span>What is 2 + 2?</span>
                        <div className="field-wrapper mt-2">
                          <input
                            className="field required"
                            id="feedbackName"
                            type="text"
                            onChange={handleChange}
                            name="asq"
                            value={data.asq}
                          />
                        </div>
                      </p>
                      {disabled && (
                        <p className="sm-p">
                          Please fill in all fields to submit registration.
                        </p>
                      )}
                      <button
                        disabled={disabled || submitting}
                        onClick={submitForm}
                        className="btn theme-element theme-element--accent mt-4"
                      >
                        {submitting ? (
                          <>
                            <i className="fas fa-spinner fa-spin" />{" "}
                            Submitting...
                          </>
                        ) : (
                          <>
                            <i className="fas fa-share" /> Submit Registration
                          </>
                        )}
                      </button>
                      {showSuccess && (
                        <p className="mt-3" data-aos="fade-up">
                          Your team has been registered. Please pay fee below
                          and you'll be all set! Once registration has been
                          confirmed, your team will be listed below.
                        </p>
                      )}
                      {showError && (
                        <p className="mt-3" data-aos="fade-up">
                          {showError}
                        </p>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section className="section location pb-5" data-aos="fade-left">
            <div className="container">
              <div className="row">
                <div className="col-lg-6">
                  <h3 className="mb-4">Payment</h3>
                  <p>
                    <strong>Tournament Fee:</strong>{" "}
                    {pricing.isEarlyBird ? (
                      <>
                        <span
                          style={{
                            textDecoration: "line-through",
                            marginRight: "8px",
                            opacity: "0.7",
                          }}
                        >
                          ${pricing.regularPrice}
                        </span>
                        ${pricing.earlyBirdPrice}
                      </>
                    ) : (
                      `$${pricing.currentPrice}`
                    )}
                    /Golfer
                  </p>
                  {pricing.isEarlyBird && (
                    <p className="mt-2 mb-4">
                      <em>
                        Early Bird Special - Register before April 30th and save
                        $15!
                      </em>
                    </p>
                  )}
                  <p className="mt-3">
                    <span>
                      <strong>Pay with Paypal:</strong>
                    </span>
                    <div className="mt-3">
                      <a
                        href="https://www.paypal.com/ncp/payment/FNNRPU8Z9SRU4"
                        className=" theme-element btn"
                      >
                        PAY NOW
                      </a>
                    </div>
                  </p>
                  <p>
                    <strong>Or send payments (cash or check) to:</strong>
                    <br />
                    <br />
                    Immaculate Heart of Mary Academy
                    <br />
                    777 221st. Avenue NW
                    <br />
                    Oak Grove, MN 55011
                  </p>
                  <p>
                    Please make checks payable to: <br />
                    "IHM Academy"
                  </p>
                </div>
              </div>
            </div>
          </section>
          {teams.length > 0 && (
            <section className="section neutral-bg">
              <div className="container">
                <h3 className="mb-4">Teams Registered</h3>
                <p>Teams listed have been confirmed.</p>
                <div className="table-wrapper">
                  {teams.length > 0 ? (
                    <table>
                      <thead>
                        <tr>
                          <th>Team Name</th>
                          <th>Player 1</th>
                          <th>Player 2</th>
                          <th>Player 3</th>
                          <th>Player 4</th>
                        </tr>
                      </thead>
                      <tbody>{mappedArray}</tbody>
                    </table>
                  ) : (
                    <div className="pulsating-square"></div>
                  )}
                </div>
                <p className="sm-p mt-3 mobile">Swipe right to view more.</p>
              </div>
            </section>
          )}
        </div>
      </main>
      {/* homepage content end */}

      {/*<GoogleReviews placeId={placeId} />*/}
      <footer className="footer accent">
        <div className="container">
          <div className="footer_copyright">
            <div className="container">
              <p className="footer_copyright-text">
                <span className="linebreak">
                  Made by Up North Creative
                  <br />
                </span>
                <span className="linebreak">All rights reserved © 2026</span>
              </p>
            </div>
          </div>
        </div>
      </footer>
      {/**/}
    </>
  );
};

export default Home;
